import { render, staticRenderFns } from "./BuyingTips.vue?vue&type=template&id=064ee02b&scoped=true&"
import script from "./BuyingTips.vue?vue&type=script&lang=ts&"
export * from "./BuyingTips.vue?vue&type=script&lang=ts&"
import style0 from "./BuyingTips.vue?vue&type=style&index=0&id=064ee02b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064ee02b",
  null
  
)

export default component.exports